import { createSlice } from "@reduxjs/toolkit";
import { sendGeneralRequest } from "../generalRequest";

const initialState = {
  utilities: [],
  specificUtilityInfo: [],
  internetSubUtilities: [],
  internetSpecificUtilityInfo: [],
  ujesjellesSubUtilities: [],
  ujesjellesSpecificUtilityInfo: [],
  vodafoneSubUtilities: [],
  taksatVendoreSubUtilities: [],
  taksatVendoreSpecificUtilityInfo: [],
  oneSubUtilities: [],
  microloanSubUtilities: [],
  microloanSpecificUtilityInfo: [],
  donationSubUtilities: [],
  donationSpecificUtilityInfo: [],
  sigurimeMotorrikeSubUtilities: [],
  sigurimeMotorrikeSpecificUtilityInfo: [],
  esimSubUtilities: [],
  esimSpecificUtilityInfo: []
};

export const paymentsSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    resetPaymentsSlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendGeneralRequest.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(sendGeneralRequest.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(sendGeneralRequest.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.endpoint === "GetServices") {
          // state.utilities = action.payload.response.serviceList.map(service => {
          //     return {
          //         publicName: service.publicName,
          //         serviceName:service.name,
          //         image: service.logoPathNew,
          //         status: service.status
          //     }
          // })
          state.utilities = action.payload.response.serviceList
            .filter((service) => (service.publicName !== "Tregtaret Online" && service.publicName !== "Wolt"))
            .map((service) => {
              return {
                publicName: service.publicName,
                serviceName: service.name,
                image: service.logoPathNew || null,
                status: service.status,
              };
            });
          state.specificUtilityInfo = action.payload.response.serviceList.map(
            (subService) => {
              if (subService.name === 'Siguracione') {
                return subService
              }
              else return subService.services[0];
            }
          );
          state.internetSubUtilities = action.payload.response.serviceList
            .filter((service) => service.name === "INTERNET")[0]
            .services.map((subService) => {
              const image = subService.Images.find(
                (image) => image.color === 1 && image.size === 1
              );
              return {
                status: subService.Status,
                publicName: subService.PublicName,
                serviceName: subService.Name,
                image: image ? image.imagePath : null,
              };
            });
          state.internetSpecificUtilityInfo =
            action.payload.response.serviceList
              .filter((service) => service.name === "INTERNET")[0]
              .services.map((subService) => {
                return subService;
              });
          state.ujesjellesSubUtilities = action.payload.response.serviceList
            .filter((service) => service.name === "UJESJELLES")[0]
            .services.map((subService) => {
              const image = subService.Images.find(
                (image) => image.color === 1 && image.size === 1
              );
              return {
                status: subService.Status,
                publicName: subService.PublicName,
                serviceName: subService.Name,
                image: image ? image.imagePath : null,
              };
            });

          state.ujesjellesSpecificUtilityInfo =
            action.payload.response.serviceList
              .filter((service) => service.name === "UJESJELLES")[0]
              .services.map((subService) => {
                return subService;
              });
          var vodafoneInfo = action.payload.response.serviceList.filter(
            (service) => service.name === "VODAFONE"
          )[0].services[0];
          state.taksatVendoreSubUtilities = action.payload.response.serviceList
            .filter((service) => service.name === "Taksa Vendore")[0]
            .services.map((subService) => {
              const image = subService.Images.find(
                (image) => image.color === 1 && image.size === 1
              );
              return {
                status: subService.Status,
                publicName: subService.PublicName,
                serviceName: subService.Name,
                image: image ? image.imagePath : null,
              };
            });
          state.taksatVendoreSpecificUtilityInfo =
            action.payload.response.serviceList
              .filter((service) => service.name === "Taksa Vendore")[0]
              .services.map((subService) => {
                return subService;
              });
          state.vodafoneSubUtilities = action.payload.response.serviceList
            .filter((service) => service.name === "VODAFONE")[0]
            .services[0].Products.map((product) => {
              const image = vodafoneInfo.Images.find(
                (image) => image.color === 1 && image.size === 1
              );
              return {
                status: product.Status,
                publicName: product.Name,
                serviceName: product.Name,
                image: image ? image.imagePath : null,
              };
            });
          var oneInfo = action.payload.response.serviceList.filter(
            (service) => service.name === "TELEKOM ALBANIA"
          )[0].services[0];
          state.oneSubUtilities = action.payload.response.serviceList
            .filter((service) => service.name === "TELEKOM ALBANIA")[0]
            .services[0].Products.map((product) => {
              const image = oneInfo.Images.find(
                (image) => image.color === 1 && image.size === 1
              );
              return {
                status: product.Status,
                publicName: product.Name === 'TELEKOM ALBANIA TOPUP' ? 'ONE TOPUP' : product.Name,
                serviceName: product.Name === 'TELEKOM ALBANIA TOPUP' ? 'ONE TOPUP' : product.Name,
                image: image ? image.imagePath : null,
              };
            });

          var donacione = action.payload.response.serviceList
            .filter((service) => service.name === "DONACIONE")[0]

          if (donacione) {
            state.donationSubUtilities = donacione
              .services.map((subService) => {
                const image = subService.Images.find(
                  (image) => image.color === 1 && image.size === 1
                );
                return {
                  status: subService.Status,
                  publicName: subService.PublicName,
                  serviceName: subService.Name,
                  image: image ? image.imagePath : null,
                };
              });
            state.donationSpecificUtilityInfo = donacione
              .services.map((subService) => {
                return subService;
              });
          }

          var mikrokredi = action.payload.response.serviceList
            .filter((service) => service.name === "MIKROKREDI")[0]

          if (mikrokredi) {
            state.microloanSubUtilities = mikrokredi
              .services.map((subService) => {
                const image = subService.Images.find(
                  (image) => image.color === 1 && image.size === 1
                );
                return {
                  status: subService.Status,
                  publicName: subService.PublicName,
                  serviceName: subService.Name,
                  image: image ? image.imagePath : null,
                };
              });

            state.microloanSpecificUtilityInfo = mikrokredi
              .services.map((subService) => {
                return subService;
              });
          }

          var sigMotorrike = action.payload.response.serviceList
            .filter((service) => service.name === "SIGURIIME_MOTORRIKE")[0]

          if (sigMotorrike) {
            state.sigurimeMotorrikeSubUtilities = sigMotorrike
              .services.map((subService) => {
                const image = subService.Images.find(
                  (image) => image.color === 1 && image.size === 1
                );
                return {
                  status: subService.Status,
                  publicName: subService.PublicName,
                  serviceName: subService.Name,
                  image: image ? image.imagePath : null,
                };
              });

            state.sigurimeMotorrikeSpecificUtilityInfo = sigMotorrike
              .services.map((subService) => {
                return subService;
              });
          }
          var esim = action.payload.response.serviceList
            .filter((service) => service.name === "ESIM")[0]

          if (esim) {
            state.esimSubUtilities = esim
              .services.map((subService) => {
                const image = subService.Images.find(
                  (image) => image.color === 1 && image.size === 1
                );
                return {
                  status: subService.Status,
                  publicName: subService.PublicName,
                  serviceName: subService.Name,
                  image: image ? image.imagePath : null,
                };
              });
            state.esimSpecificUtilityInfo = esim
              .services.map((subService) => {
                return subService;
              });
          }

        }
      });
  },
});
export const { resetPaymentsSlice } = paymentsSlice.actions;

export const selectPaymentsState = (state) => state.payments;

export default paymentsSlice.reducer;
